// Item codes ("AB-01", "CB-01-01") compared as people read them, like ItemsController::compareCodes on the backend:
// part by part, digit runs as numbers (AB-1 equals AB-01, AB-9 comes before AB-10) and other text without regard to
// case, then the code with fewer parts first.
export const compareCodes = (a: string, b: string) => {
  const parts = (code: string) =>
    code.split(/(\d+)/).filter((part) => part !== "");
  const aParts = parts(a);
  const bParts = parts(b);

  for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
    let result: number;

    if (/^\d+$/.test(aParts[i]) && /^\d+$/.test(bParts[i])) {
      const aNumber = aParts[i].replace(/^0+/, "");
      const bNumber = bParts[i].replace(/^0+/, "");

      result =
        aNumber.length - bNumber.length ||
        (aNumber < bNumber ? -1 : aNumber > bNumber ? 1 : 0);
    } else {
      const aText = aParts[i].toLowerCase();
      const bText = bParts[i].toLowerCase();

      result = aText < bText ? -1 : aText > bText ? 1 : 0;
    }

    if (result !== 0) return result;
  }

  return aParts.length - bParts.length;
};

// Whether a code falls between two codes, both included; either end may be blank, and reversed ends are swapped.
export const inCodeRange = (code: string, from: string, to: string) => {
  const [low, high] =
    from && to && compareCodes(from, to) > 0 ? [to, from] : [from, to];

  return (
    (!low || compareCodes(code, low) >= 0) &&
    (!high || compareCodes(code, high) <= 0)
  );
};
